<template>
  <div id="app">
    <app-header />
    <loader />
    <router-view />
  </div>
</template>

<script>
import AppHeader from "@/components/layout/AppHeader.vue";
import Loader from "@/components/layout/Loader.vue";

export default {
  name: "App",
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    AppHeader,
    Loader,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
